import { ZoneForm } from "@features/stock/components/ZoneForm";
import { API_ENDPOINTS, ROUTES } from "@features/stock/config/constants";
import api from "@lib/api";
import { queryKeys } from "@lib/api/queryKeys";
import { usePermissions } from "@lib/hooks/usePermissions";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/zones/$id/edit")({
  loader: requirePermission(PERMISSIONS.STOCK.ZONES.EDIT),
  component: EditZoneComponent,
});

function EditZoneComponent() {
  const { id } = Route.useParams();
  const { can } = usePermissions();
  const navigate = useNavigate();

  const { data } = useQuery({
    queryKey: queryKeys.stock.zones.detail(Number(id)),
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.ZONES.DETAIL(id));
      return response.data;
    },
  });

  if (!can("stock.zones.edit")) {
    return <div className="p-6">Accès non autorisé</div>;
  }

  const handleSuccess = () => {
    navigate({ to: ROUTES.STOCK.ZONES.LIST });
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Modifier Zone</h1>
      {data && <ZoneForm mode="edit" initialData={data} onSuccess={handleSuccess} />}
    </div>
  );
}
